import React from 'react';
import styled from 'styled-components';

const SVGLoader = styled.svg`
	&.loading-icon {
		animation: spin 1s linear infinite;
	}

	@keyframes spin {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}
`;

export function FFLoader(props) {
	return (
		<SVGLoader
			xmlns='http://www.w3.org/2000/svg'
			width='22'
			height='22'
			className='loading-icon'
			viewBox='0 0 22 22'
			fill='none'
			{...props}
		>
			<path
				fill='currentColor'
				d='M9 18A9 9 0 1 1 9 0v2a7 7 0 1 0 7 7h2a9.01 9.01 0 0 1-9 9z'
				transform='translate(2.001 2)'
			/>
		</SVGLoader>
	);
}

export const LoaderGif = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 200 200'
			{...props}
			width='100px'
		>
			<radialGradient
				id='a'
				cx={0.66}
				fx={0.66}
				cy={0.313}
				fy={0.313}
				gradientTransform='scale(1.5)'
			>
				<stop offset={0} stopColor='var(--selectedColor)' />
				<stop offset={0.3} stopColor='var(--selectedColor)' stopOpacity={0.9} />
				<stop offset={0.6} stopColor='var(--selectedColor)' stopOpacity={0.6} />
				<stop offset={0.8} stopColor='var(--selectedColor)' stopOpacity={0.3} />
				<stop offset={1} stopColor='var(--selectedColor)' stopOpacity={0} />
			</radialGradient>
			<circle
				transform-origin='center'
				fill='none'
				stroke='url(#a)'
				strokeWidth={15}
				strokeLinecap='round'
				strokeDasharray='200 1000'
				cx={100}
				cy={100}
				r={70}
			>
				<animateTransform
					type='rotate'
					attributeName='transform'
					calcMode='spline'
					dur={2}
					values='360;0'
					keyTimes='0;1'
					keySplines='0 0 1 1'
					repeatCount='indefinite'
				/>
			</circle>
			<circle
				transform-origin='center'
				fill='none'
				opacity={0.2}
				strokeWidth={15}
				strokeLinecap='round'
				cx={100}
				cy={100}
				r={70}
			/>
		</svg>
	);
};
export const CloseCircle = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='16'
			height='16'
			viewBox='0 0 16 16'
			{...props}
		>
			<path
				d='M10.393 6 8.667 7.727 6.94 6 6 6.94l1.727 1.727L6 10.393l.94.94 1.727-1.726 1.727 1.727.94-.94-1.727-1.727 1.726-1.727zM8.667 2a6.667 6.667 0 1 0 6.667 6.667A6.661 6.661 0 0 0 8.667 2zm0 12A5.333 5.333 0 1 1 14 8.667 5.34 5.34 0 0 1 8.667 14z'
				transform='translate(-.667 -.667)'
				fill='currentColor'
			/>
		</svg>
	);
};

export const Home = (props: any) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='28'
			height='28'
			viewBox='0 0 28 28'
			{...props}
		>
			<g data-name='Group 17915'>
				<path data-name='Path 9' d='M0 0h28v28H0z' fill='none' />
			</g>
			<g data-name='Group 17916'>
				<path
					data-name='Path 10'
					d='m13.333 5.917 7 5.25v10.5h-14v-10.5l7-5.25m0-2.917L4 10v14h18.667V10z'
					transform='translate(.667 .5)'
					fill='rgba(0,0,0,.6)'
				/>
			</g>
		</svg>
	);
};

export const HomeFilled = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='28'
			height='28'
			viewBox='0 0 28 28'
		>
			<path data-name='Path 11' d='M0 0h28v28H0z' fill='none' />
			<path
				data-name='Path 12'
				d='M13.333 3 4 10v14h18.667V10z'
				transform='translate(.667 .5)'
				fill='#3b44c4'
			/>
		</svg>
	);
};

export const Chats = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='28'
			height='28'
			viewBox='0 0 28 28'
		>
			<path data-name='Path 15' d='M0 0h28v28H0z' fill='none' />
			<path
				data-name='Path 16'
				d='M17.167 4.333V12.5H5.7l-.688.688-.677.677V4.333h12.832M18.333 2H3.167A1.17 1.17 0 0 0 2 3.167V19.5l4.667-4.667h11.666a1.17 1.17 0 0 0 1.167-1.166v-10.5A1.17 1.17 0 0 0 18.333 2zm5.833 4.667h-2.333v10.5H6.667V19.5a1.17 1.17 0 0 0 1.167 1.167h12.833l4.667 4.667V7.833a1.17 1.17 0 0 0-1.167-1.166z'
				transform='translate(.333 .333)'
				fill='rgba(0,0,0,.6)'
			/>
		</svg>
	);
};
export const GetinTouch = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='28'
			height='28'
			viewBox='0 0 28 28'
		>
			<path data-name='Path 15577' d='M0 0h28v28H0z' fill='none' />
			<path
				data-name='Path 15578'
				d='M22.833 17.583a13.254 13.254 0 0 1-4.165-.665 1.3 1.3 0 0 0-.362-.058 1.2 1.2 0 0 0-.828.338l-2.567 2.567a17.587 17.587 0 0 1-7.688-7.677L9.79 9.51a1.145 1.145 0 0 0 .292-1.178 13.254 13.254 0 0 1-.665-4.165A1.17 1.17 0 0 0 8.25 3H4.167A1.17 1.17 0 0 0 3 4.167 19.832 19.832 0 0 0 22.833 24 1.17 1.17 0 0 0 24 22.833V18.75a1.17 1.17 0 0 0-1.167-1.167zM5.368 5.333h1.75a15.47 15.47 0 0 0 .537 3.022l-1.4 1.412a17.487 17.487 0 0 1-.887-4.433zm16.3 16.3a17.385 17.385 0 0 1-4.433-.887l1.4-1.4a14.878 14.878 0 0 0 3.033.525z'
				transform='translate(.5 .5)'
				fill='rgba(0,0,0,.6)'
			/>
			<path
				data-name='Path 15584'
				d='M24 6H14v7h10zm-1.429 2.8L19 11.25 15.429 8.8V7.4L19 9.85l3.571-2.45z'
				transform='translate(0 -2.5)'
				fill='rgba(0,0,0,.6)'
			/>
		</svg>
	);
};

export const GetinTouchFilled = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			data-name='perm_phone_msg_black_24dp (1)'
			width='28'
			height='28'
			viewBox='0 0 28 28'
		>
			<path data-name='Path 15585' d='M0 0h28v28H0z' fill='none' />
			<path
				data-name='Path 15586'
				d='M22.833 17.583a13.254 13.254 0 0 1-4.165-.665 1.191 1.191 0 0 0-1.19.28l-2.567 2.567a17.587 17.587 0 0 1-7.688-7.677L9.79 9.51a1.145 1.145 0 0 0 .292-1.178 13.254 13.254 0 0 1-.665-4.165A1.17 1.17 0 0 0 8.25 3H4.167A1.17 1.17 0 0 0 3 4.167 19.832 19.832 0 0 0 22.833 24 1.17 1.17 0 0 0 24 22.833V18.75a1.17 1.17 0 0 0-1.167-1.167z'
				transform='translate(.5 .5)'
				fill='#3b44c4'
			/>
			<path
				data-name='Path 15587'
				d='M24 6H14v7h10zm-1.429 2.8L19 11.25 15.429 8.8V7.4L19 9.85l3.571-2.45z'
				transform='translate(0 -2.5)'
				fill='#3b44c4'
			/>
		</svg>
	);
};

export const Feedback = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='28'
			height='28'
			viewBox='0 0 28 28'
		>
			<path data-name='Path 21' d='M0 0h28v28H0zm0 0h28v28H0z' fill='none' />
			<path
				data-name='Path 22'
				d='M14 7a1.17 1.17 0 0 0-1.167-1.167H6.79l.77-3.71.023-.268A1.354 1.354 0 0 0 7.2.922L6.277 0 .513 5.763A1.756 1.756 0 0 0 0 7v7.583a1.748 1.748 0 0 0 1.75 1.75h7.875a1.76 1.76 0 0 0 1.61-1.062L13.872 9.1A1.7 1.7 0 0 0 14 8.458zm-2.333 1.318L9.24 14H2.333V7.245l2.252-2.252-.665 3.174h7.747zm14.583 3.349h-7.875a1.76 1.76 0 0 0-1.61 1.062L14.128 18.9a1.7 1.7 0 0 0-.128.642V21a1.17 1.17 0 0 0 1.167 1.167h6.043l-.77 3.71-.023.28a1.354 1.354 0 0 0 .385.933l.922.91 5.763-5.763A1.756 1.756 0 0 0 28 21v-7.583a1.748 1.748 0 0 0-1.75-1.75zm-.583 9.088-2.252 2.252.665-3.173h-7.747v-.152L18.76 14h6.907z'
				fill='rgba(0,0,0,.6)'
			/>
		</svg>
	);
};

export function CheckboxTick(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			data-name='check_box_black_24dp (3)'
			width='24'
			height='24'
			viewBox='0 0 24 24'
		>
			<path data-name='Path 13864' d='M0 0h24v24H0z' fill='none' />
			<path
				data-name='Path 13865'
				d='M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm-9 14-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z'
				fill={props.fill ? props.fill : '#3b44c4'}
			/>
		</svg>
	);
}

export const CheckBoxUntick = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			data-name='check_box_outline_blank_black_24dp (2)'
			width='24'
			height='24'
			viewBox='0 0 24 24'
		>
			<path data-name='Path 13856' d='M0 0h24v24H0z' fill='none' />
			<path
				data-name='Path 13857'
				d='M19 5v14H5V5h14m0-2H5a2.006 2.006 0 0 0-2 2v14a2.006 2.006 0 0 0 2 2h14a2.006 2.006 0 0 0 2-2V5a2.006 2.006 0 0 0-2-2z'
				fill='rgba(0,0,0,.6)'
			/>
		</svg>
	);
};

export const RadioUncheck = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			data-name='radio_button_unchecked_black_24dp (2)'
			width='24'
			height='24'
			viewBox='0 0 24 24'
		>
			<path data-name='Path 13862' d='M0 0h24v24H0z' fill='none' />
			<path
				data-name='Path 13863'
				d='M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z'
				fill='rgba(0,0,0,.6)'
			/>
		</svg>
	);
};

export const RadioCheck = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			data-name='radio_button_checked_black_24dp (2)'
			width='24'
			height='24'
			viewBox='0 0 24 24'
		>
			<path data-name='Path 13860' d='M0 0h24v24H0z' fill='none' />
			<path
				data-name='Path 13861'
				d='M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z'
				fill='#3b44c4'
			/>
			<circle
				data-name='Ellipse 592'
				cx='5'
				cy='5'
				r='5'
				transform='translate(7 7)'
				fill='#3b44c4'
			/>
		</svg>
	);
};
export const StarSVG = (props) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={props.width ? props.width : '13'}
		height={props.height ? props.height : '13'}
		fill='rgb(177, 177, 177)'
		className='bi bi-star-fill'
		viewBox='0 0 16 16'
		style={{ marginRight: '2px' }}
	>
		<path d='M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z' />
	</svg>
);

export const HalfStarSVG = (props) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={props.width ? props.width : '13'}
		height={props.height ? props.height : '13'}
		fill='rgb(177, 177, 177)'
		className='bi bi-star-half'
		viewBox='0 0 16 16'
		style={{ marginRight: '2px' }}
	>
		<path d='M5.354 5.119 7.538.792A.52.52 0 0 1 8 .5c.183 0 .366.097.465.292l2.184 4.327 4.898.696A.54.54 0 0 1 16 6.32a.55.55 0 0 1-.17.445l-3.523 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256a.5.5 0 0 1-.146.05c-.342.06-.668-.254-.6-.642l.83-4.73L.173 6.765a.55.55 0 0 1-.172-.403.6.6 0 0 1 .085-.302.51.51 0 0 1 .37-.245zM8 12.027a.5.5 0 0 1 .232.056l3.686 1.894-.694-3.957a.56.56 0 0 1 .162-.505l2.907-2.77-4.052-.576a.53.53 0 0 1-.393-.288L8.001 2.223 8 2.226z' />
	</svg>
);
export const EmptyStarSVG = (props) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={props.width ? props.width : '13'}
		height={props.height ? props.height : '13'}
		fill='rgb(177, 177, 177)'
		className='bi bi-star'
		viewBox='0 0 16 16'
		style={{ marginRight: '2px' }}
	>
		<path d='M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0 .393-.288L8 2.223l1.847 3.658a.53.53 0 0 0 .393.288l4.052.575-2.906 2.77a.56.56 0 0 0-.163.506l.694 3.957-3.686-1.894a.5.5 0 0 0-.461 0z' />
	</svg>
);
export const TrendingIcon = (props) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={15.409}
		height={9.369}
		{...props}
	>
		<g
			fill='none'
			stroke='#a4a4a4'
			strokeLinecap='round'
			strokeLinejoin='round'
			strokeWidth={1.5}
		>
			<path
				data-name='Path 20497'
				d='M14.348 1.061 8.611 6.799l-3.02-3.02-4.53 4.53'
			/>
			<path data-name='Path 20498' d='M10.724 1.061h3.624v3.624' />
		</g>
	</svg>
);
export const AIIcon = (props) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={19.911}
		height={22.566}
		{...props}
	>
		<defs>
			<linearGradient
				id='a'
				x1={0.167}
				y1={0.755}
				x2={0.789}
				y2={0.256}
				gradientUnits='objectBoundingBox'
			>
				<stop offset={0} stopColor='#0125ba' />
				<stop offset={1} stopColor='#de093a' />
			</linearGradient>
			<linearGradient
				id='b'
				x1={0.5}
				y1={-0.336}
				x2={-0.938}
				y2={0.759}
				gradientUnits='objectBoundingBox'
			>
				<stop offset={0} stopColor='#de006f' />
				<stop offset={1} stopColor='#0418af' />
			</linearGradient>
		</defs>
		<g data-name='AI Icon'>
			<path
				data-name='Path 20619'
				d='m32.637 39.139.328-1.639.328 1.639a7.646 7.646 0 0 0 6 6l1.639.328-1.639.328a7.646 7.646 0 0 0-6 6l-.328 1.639-.328-1.639a7.646 7.646 0 0 0-6-6L25 45.464l1.639-.328a7.646 7.646 0 0 0 5.998-5.997Z'
				transform='translate(-22.346 -30.863)'
				fill='url(#a)'
			/>
			<path
				data-name='Path 20620'
				d='m21.4 17.681.2-1.015.2 1.015a4.734 4.734 0 0 0 3.715 3.719l1.015.2-1.015.2a4.734 4.734 0 0 0-3.715 3.715l-.2 1.015-.2-1.015a4.734 4.734 0 0 0-3.719-3.715l-1.015-.2 1.015-.2a4.734 4.734 0 0 0 3.719-3.719Z'
				fill='url(#b)'
				transform='translate(-16.667 -16.667)'
			/>
			<path
				data-name='Path 20621'
				d='m65.682 21.516.137-.683.137.683a3.186 3.186 0 0 0 2.5 2.5l.683.137-.683.137a3.186 3.186 0 0 0-2.5 2.5l-.137.683-.137-.683a3.186 3.186 0 0 0-2.5-2.5l-.683-.137.683-.137a3.186 3.186 0 0 0 2.5-2.5Z'
				transform='translate(-49.227 -19.506)'
				fill='url(#b)'
			/>
		</g>
	</svg>
);

export const FlyfishIcon = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			xmlnsXlink='http://www.w3.org/1999/xlink'
			width={244.663}
			height={31.369}
			{...props}
		>
			<g data-name='Home UI SS' transform='translate(-1568.313 -984.328)'>
				<g data-name='Powered by'>
					<g data-name='Group 34468'>
						<g data-name='Group 34467'>
							<text
								data-name='Powered by'
								transform='translate(1568.313 1005.513)'
								fill='#fff'
								fontSize={17}
								fontFamily='Metropolis-Regular, Metropolis'
							>
								<tspan
									x={0}
									y={0}
									xmlSpace='preserve'
									style={{ fontFamily: 'var(--fontFamily)' }}
								>
									{'Powered by  '}
								</tspan>
							</text>
						</g>
					</g>
				</g>
				<image
					data-name='Flyfish logo'
					width={129.663}
					height={31.369}
					transform='translate(1683.313 984.328)'
					xlinkHref='data:image/png;base64,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'
				/>
			</g>
		</svg>
	);
};
export const ShopperStopLine = (props) => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width={414} height={93} {...props}>
			<defs>
				<clipPath id='a'>
					<path
						data-name='Rectangle 20665'
						transform='translate(770 680)'
						fill='#fff'
						stroke='#707070'
						d='M0 0h414v93H0z'
					/>
				</clipPath>
			</defs>
			<g
				data-name='Mask Group 32336'
				transform='translate(-770 -680)'
				clipPath='url(#a)'
			>
				<path
					data-name='Path 20762'
					d='M775 748.45S924.882 702 965.491 718.077s-3.83 40.088-10.719 22.55 134.927-32.18 210.568-22.547'
					fill='none'
					stroke='#fff'
					opacity={0.405}
				/>
			</g>
		</svg>
	);
};

export const ShopperstopLogo = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={343.549}
			height={35.062}
			{...props}
		>
			<g data-name='SHoppers stop logo' fill='#fff'>
				<path
					data-name='Path 20717'
					d='M25.836 32.604h1.23a6.7 6.7 0 0 0 1.845-.308c.308-.308.308-.615.615-.923V11.995c0-.308-.308-.615-.615-.923a5.323 5.323 0 0 0-2.153-.308h-.923l-.307-1.845 11.995-.308.308 1.845h-1.23a5.323 5.323 0 0 0-2.153.308c-.308 0-.308.308-.615.923v8h11.995v-4.309a10.613 10.613 0 0 0-.308-3.691c0-.308-.308-.615-.308-.923a5.323 5.323 0 0 0-2.153-.308h-.923l-.308-1.844 12.3-.308.308 1.845h-.923c-1.538 0-1.845 0-2.153.308-.308 0-.308.308-.615.923v19.376c0 .308.308.615.615.923a4.465 4.465 0 0 0 1.845.308h.923l.308 1.845h-12.3l-.308-1.846h1.538a6.7 6.7 0 0 0 1.845-.308 2.365 2.365 0 0 0 .615-.923c0-.615.308-2.153.308-4v-5.533h-12v9.227c0 .615.308.923.615.923a4.464 4.464 0 0 0 1.845.308h1.234l.308 1.845H26.143Z'
				/>
				<path
					data-name='Path 20718'
					d='M71.97 35.062a14.733 14.733 0 0 1-10.148-3.691c-2.768-2.461-4-5.844-4-9.842a11.9 11.9 0 0 1 4-9.534 13.97 13.97 0 0 1 9.84-3.691 14.733 14.733 0 0 1 10.15 3.691c2.768 2.461 4 5.536 4 9.842a11.9 11.9 0 0 1-4 9.534c-2.461 2.461-5.536 3.691-9.842 3.691Zm0-24.605a7.944 7.944 0 0 0-6.459 2.768c-1.538 1.845-2.153 4.613-2.153 8.612 0 3.691.615 6.766 2.153 8.612s3.691 2.768 6.766 2.768a7.743 7.743 0 0 0 6.151-2.768c1.538-1.845 2.153-4.613 2.153-8.612 0-3.691-.615-6.459-2.153-8.612a7.944 7.944 0 0 0-6.458-2.768Z'
				/>
				<path
					data-name='Path 20719'
					d='m89.502 34.447-.308-1.846h1.23a4.464 4.464 0 0 0 1.845-.308 2.365 2.365 0 0 0 .615-.923 13.765 13.765 0 0 0 .308-3.691V15.685a11.619 11.619 0 0 0-.308-3.691c0-.308-.308-.615-.308-.923a7.51 7.51 0 0 0-2.153-.308H89.5l-.306-1.844h9.534a29.193 29.193 0 0 1 6.151.615 7.381 7.381 0 0 1 3.691 2.153 6.667 6.667 0 0 1 1.538 4.306 8.514 8.514 0 0 1-.923 4 5.427 5.427 0 0 1-2.768 2.461c-1.23.615-3.076.923-6.151.923h-2.46v8.3c0 .615.308.615.615.923a6.7 6.7 0 0 0 1.845.308h1.228l.308 1.845h-12.3Zm9.534-13.533a10.52 10.52 0 0 0 3.383-.308 4.1 4.1 0 0 0 1.845-1.538 5.058 5.058 0 0 0 .615-3.076c0-1.845-.308-3.383-1.23-4-.923-.923-2.461-1.23-4.613-1.23h-1.542v10.457Z'
				/>
				<path
					data-name='Path 20720'
					d='m113.799 34.447-.308-1.845h1.23a4.464 4.464 0 0 0 1.845-.308c.308-.308.615-.308.615-.923V11.995c0-.308-.308-.615-.615-.923a10.913 10.913 0 0 0-2.153-.308h-.923l-.306-1.845h9.534a31.725 31.725 0 0 1 6.151.615 7.381 7.381 0 0 1 3.691 2.153 6.667 6.667 0 0 1 1.538 4.306 8.514 8.514 0 0 1-.923 4 5.427 5.427 0 0 1-2.768 2.461c-1.23.615-3.076.923-6.151.923h-2.153v8.3c0 .308.308.615.615.923a4.464 4.464 0 0 0 1.845.308h1.23l.308 1.845h-12.3Zm9.535-13.533a11.532 11.532 0 0 0 3.383-.308 4.1 4.1 0 0 0 1.845-1.538 5.058 5.058 0 0 0 .615-3.076c0-1.845-.308-3.383-1.23-4-.923-.923-2.461-1.23-4.306-1.23h-1.538v10.457Z'
				/>
				<path
					data-name='Path 20721'
					d='m137.789 34.447-.308-2.153h1.23c1.538 0 1.845-.308 1.845-.308.308-.308.615-.615.615-.923V11.687a1.347 1.347 0 0 0-.308-.923 7.51 7.51 0 0 0-2.153-.308h-.308l-.308-1.845 18.764-.307.923 7.074-1.845.308v-.308c-.615-1.845-.923-3.076-1.538-3.691a3.921 3.921 0 0 0-1.845-1.23 10.613 10.613 0 0 0-3.691-.308h-3.081v9.227h2.153c1.23 0 1.845 0 2.153-.308s.615-.308.615-.615a10.914 10.914 0 0 0 .312-2.149v-.308l1.845-.308.308 9.534-1.845.308v-.308a23.85 23.85 0 0 0-.308-2.768.661.661 0 0 0-.615-.615 17.342 17.342 0 0 0-2.153-.308h-2.465v5.229c0 4 .308 4.613.615 4.921a3.6 3.6 0 0 0 2.461.615h1.845a9.1 9.1 0 0 0 3.076-.615 5.764 5.764 0 0 0 2.153-1.845 12.062 12.062 0 0 0 1.538-4v-.308l1.845-.308v1.231l-.308 8h-21.217Z'
				/>
				<path
					data-name='Path 20722'
					d='M163.009 32.604h1.538a4.464 4.464 0 0 0 1.845-.308c.308-.308.615-.308.615-.923V11.995c0-.308-.308-.615-.308-.923a5.323 5.323 0 0 0-2.153-.308h-.923l-.308-1.845 4-.308c2.153 0 4-.308 5.536-.308a28.309 28.309 0 0 1 5.844.615 10.635 10.635 0 0 1 3.691 2.153 5.847 5.847 0 0 1 1.538 4 6.259 6.259 0 0 1-1.845 4.613 11.236 11.236 0 0 1-4.306 2.153 35.535 35.535 0 0 1 4 4.613 43.009 43.009 0 0 0 4.306 4.921 6.449 6.449 0 0 0 3.383 1.23h.308l.308 1.845h-7.385c-1.23-.923-3.076-3.076-5.536-6.766-.615-.923-1.538-1.845-2.461-3.076s-1.538-1.538-1.538-1.845c-.308-.308-.615-.308-1.23-.308h-.615v8.613c0 .308.308.615.615.923s.923.308 1.845.308h1.538l.308 1.845h-12.918Zm8.611-12h2.153c.923 0 1.538-.308 2.461-.308a6.723 6.723 0 0 0 1.538-.923 6.724 6.724 0 0 0 .923-1.538 6 6 0 0 0 .308-2.461 4.9 4.9 0 0 0-1.23-3.691c-.615-.923-2.461-1.23-5.229-1.23h-1.23Z'
				/>
				<path
					data-name='Path 20723'
					d='M202.992 35.062a9.043 9.043 0 0 1-6.766-2.768c-.308.308-.308.923-.615 1.538v.308l-1.845.308-.308-8.92 1.845-.308v.308c1.23 4.921 3.383 7.382 7.074 7.382a4.9 4.9 0 0 0 3.691-1.23 3.949 3.949 0 0 0 1.23-3.076 3.757 3.757 0 0 0-1.23-2.768 13.2 13.2 0 0 0-4.31-2.461c-2.153-.923-3.691-1.845-4.613-2.153a5.427 5.427 0 0 1-2.457-2.768 7.14 7.14 0 0 1 .923-8.3 6.985 6.985 0 0 1 4.921-1.85 9.1 9.1 0 0 1 3.076.615 4.783 4.783 0 0 1 2.461 1.845 1.849 1.849 0 0 0 .308-1.23v-.308l1.845-.308v7.386l-1.538.308v-.308c-.615-1.845-1.23-3.383-2.461-4.306a5.675 5.675 0 0 0-3.691-1.538 3.76 3.76 0 0 0-2.768.923 3.322 3.322 0 0 0-.923 2.153 2.8 2.8 0 0 0 1.23 2.461 15.8 15.8 0 0 0 4.306 2.461c2.153.923 3.691 1.538 4.613 2.461a9.361 9.361 0 0 1 2.461 2.461 8.19 8.19 0 0 1 .923 3.691 8.842 8.842 0 0 1-2.153 5.533c-.923 1.535-2.768 2.458-5.229 2.458Z'
				/>
				<path
					data-name='Path 20724'
					d='m269.733 34.447-.308-1.845h1.845a6.7 6.7 0 0 0 1.845-.308c.308-.308.308-.615.615-.923V10.764h-3.076a8.571 8.571 0 0 0-3.076.308c-.308 0-.923.615-1.23 1.23a16.322 16.322 0 0 0-.923 3.383v.308l-1.845.308V9.227l24.913-.308.308 6.766-1.538.308v-.308a9.767 9.767 0 0 0-1.23-3.383c-.308-.615-.923-.923-1.23-1.23a17 17 0 0 0-2.768-.308h-3.383v20.607c0 .308.308.923.615.923a6.7 6.7 0 0 0 1.845.308h1.538l.308 1.845Z'
				/>
				<path
					data-name='Path 20725'
					d='M306.026 35.062a14.733 14.733 0 0 1-10.15-3.691 13.681 13.681 0 0 1-4-9.842 11.9 11.9 0 0 1 4-9.534 13.969 13.969 0 0 1 9.842-3.691 13.464 13.464 0 0 1 9.842 3.691c2.768 2.461 4 5.536 4 9.842a11.9 11.9 0 0 1-4 9.534c-2.153 2.461-5.536 3.691-9.534 3.691Zm0-24.605a7.944 7.944 0 0 0-6.459 2.768c-1.538 1.845-2.153 4.613-2.153 8.612s.615 6.766 2.153 8.612 3.691 2.768 6.766 2.768a7.743 7.743 0 0 0 6.151-2.768c1.538-1.845 2.153-4.613 2.153-8.612 0-3.691-.615-6.459-2.153-8.612a7.944 7.944 0 0 0-6.458-2.768Z'
				/>
				<path
					data-name='Path 20726'
					d='m323.25 34.447-.308-1.845h1.23c.923 0 1.538 0 1.845-.308s.615-.308.615-.923V11.995c0-.308-.308-.615-.615-.923a5.323 5.323 0 0 0-2.153-.308h-.923l-.306-1.845h9.534a29.193 29.193 0 0 1 6.151.615 7.381 7.381 0 0 1 3.691 2.153 6.667 6.667 0 0 1 1.538 4.306 8.513 8.513 0 0 1-.923 4 4.365 4.365 0 0 1-2.768 2.461c-1.23.615-3.076.923-6.151.923h-2.153v8.3c0 .308.308.615.615.923a4.464 4.464 0 0 0 1.845.308h1.23l.308 1.845h-12.3Zm9.227-13.533a11.532 11.532 0 0 0 3.383-.308c.615-.308 1.538-.615 1.845-1.538a5.2 5.2 0 0 0 .923-3.076c0-1.845-.308-3.076-1.23-4s-2.461-1.23-4.613-1.23h-1.538v10.457Z'
				/>
				<path
					data-name='Path 20727'
					d='M11.687 35.062a12.318 12.318 0 0 1-8.919-3.691 5.794 5.794 0 0 0-.615 2.461v.308l-1.845.308V22.76l1.845-.308v.308Q4.46 32.91 11.38 32.91a7.235 7.235 0 0 0 5.229-1.845 5.414 5.414 0 0 0 1.845-4 7.96 7.96 0 0 0-1.23-4.306 20.537 20.537 0 0 0-6.151-3.383 39.778 39.778 0 0 1-6.151-2.768c-1.845-1.23-3.383-2.153-4-3.691A8.944 8.944 0 0 1 0 8.612a8.588 8.588 0 0 1 2.461-6.151A9.926 9.926 0 0 1 8.919 0a15.583 15.583 0 0 1 4 .615 8.625 8.625 0 0 1 3.691 2.461 5.7 5.7 0 0 0 .615-2.153V.615L19.07.307l.308 9.534-1.845.308v-.308c-.923-2.768-1.845-4.613-3.076-5.844a8.025 8.025 0 0 0-5.229-2.153 6.084 6.084 0 0 0-4.306 1.538 4.625 4.625 0 0 0-1.23 3.383 5.093 5.093 0 0 0 1.538 3.691 39.133 39.133 0 0 0 6.151 3.691 27.677 27.677 0 0 1 6.151 3.076 8.326 8.326 0 0 1 3.382 3.077 8.009 8.009 0 0 1 1.23 4.613 9.54 9.54 0 0 1-3.076 7.382c-1.537 1.845-4.305 2.767-7.381 2.767Z'
				/>
				<path
					data-name='Path 20728'
					d='M250.05 35.063a12.318 12.318 0 0 1-8.919-3.691 5.794 5.794 0 0 0-.615 2.461v.308l-1.846.307V22.76l1.845-.308v.308c1.538 6.767 4.614 10.148 9.535 10.148 2.153 0 4-.615 4.921-1.845a5.414 5.414 0 0 0 1.845-4 7.96 7.96 0 0 0-1.23-4.306 20.537 20.537 0 0 0-6.151-3.383 39.78 39.78 0 0 1-6.152-2.766 9.777 9.777 0 0 1-3.691-3.383 8.356 8.356 0 0 1-.923-4.306 8.588 8.588 0 0 1 2.461-6.151 9.926 9.926 0 0 1 6.459-2.46 15.583 15.583 0 0 1 4 .615 12.868 12.868 0 0 1 3.691 2.461 7.824 7.824 0 0 0 .615-2.153V.923l1.845-.308v9.534h-1.538v-.308c-.923-2.768-1.845-4.613-3.076-5.844a8.025 8.025 0 0 0-5.229-2.153c-1.845 0-3.383.615-4 1.538a4.625 4.625 0 0 0-1.23 3.383 5.093 5.093 0 0 0 1.538 3.691 21.421 21.421 0 0 0 6.151 3.691 52.721 52.721 0 0 1 6.151 3.076 8.326 8.326 0 0 1 3.383 3.076 8.009 8.009 0 0 1 1.23 4.613 9.118 9.118 0 0 1-3.076 7.382 12.046 12.046 0 0 1-7.994 2.769Z'
				/>
			</g>
		</svg>
	);
};
export const ShopperstopLogoMobile = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={228}
			height={23.27}
			{...props}
		>
			<path
				data-name='Path 20717'
				d='M17.142 21.636h.816a4.449 4.449 0 0 0 1.225-.2c.2-.2.2-.408.408-.612V7.96c0-.2-.2-.408-.408-.612a3.533 3.533 0 0 0-1.429-.2h-.612l-.2-1.229 7.961-.2.2 1.225h-.816a3.532 3.532 0 0 0-1.429.2c-.2 0-.2.2-.408.612v5.307h7.961v-2.857a7.043 7.043 0 0 0-.2-2.449c0-.2-.2-.408-.2-.612a3.532 3.532 0 0 0-1.429-.2h-.612l-.2-1.225 8.165-.2.2 1.225h-.612c-1.021 0-1.225 0-1.429.2-.2 0-.2.2-.408.612v12.854c0 .2.2.408.408.612a2.963 2.963 0 0 0 1.225.2h.612l.2 1.225h-8.167l-.2-1.225h1.021a4.45 4.45 0 0 0 1.225-.2 1.569 1.569 0 0 0 .408-.612c0-.408.2-1.429.2-2.654v-3.673h-7.961v6.127c0 .408.2.612.408.612a2.963 2.963 0 0 0 1.225.2h.816l.2 1.225H17.35Z'
				fill='#fff'
			/>
			<path
				data-name='Path 20718'
				d='M47.763 23.269a9.778 9.778 0 0 1-6.736-2.449 8.328 8.328 0 0 1-2.653-6.532 7.9 7.9 0 0 1 2.654-6.328 9.271 9.271 0 0 1 6.531-2.449 9.778 9.778 0 0 1 6.736 2.449 8.05 8.05 0 0 1 2.654 6.532 7.9 7.9 0 0 1-2.654 6.328 8.619 8.619 0 0 1-6.532 2.449Zm0-16.329a5.272 5.272 0 0 0-4.289 1.837c-1.021 1.225-1.429 3.062-1.429 5.715 0 2.449.408 4.491 1.429 5.715a5.422 5.422 0 0 0 4.491 1.837 5.139 5.139 0 0 0 4.085-1.833c1.024-1.228 1.424-3.065 1.424-5.719a9.5 9.5 0 0 0-1.429-5.715 5.272 5.272 0 0 0-4.282-1.837Z'
				fill='#fff'
			/>
			<path
				data-name='Path 20719'
				d='m59.394 22.861-.2-1.225h.816a2.963 2.963 0 0 0 1.225-.2 1.569 1.569 0 0 0 .408-.612 9.135 9.135 0 0 0 .2-2.449V10.41a7.711 7.711 0 0 0-.2-2.449c0-.2-.2-.408-.2-.612a4.984 4.984 0 0 0-1.429-.2h-.62l-.2-1.23h6.328a19.374 19.374 0 0 1 4.082.408 4.9 4.9 0 0 1 2.449 1.429 4.425 4.425 0 0 1 1.021 2.858 5.65 5.65 0 0 1-.612 2.654 3.6 3.6 0 0 1-1.837 1.633 9.4 9.4 0 0 1-4.082.612h-1.634v5.506c0 .408.2.408.408.612a4.45 4.45 0 0 0 1.225.2h.816l.2 1.225h-8.164Zm6.328-8.981a6.982 6.982 0 0 0 2.245-.2 2.721 2.721 0 0 0 1.227-1.025 3.357 3.357 0 0 0 .408-2.041c0-1.225-.2-2.245-.816-2.654a4.237 4.237 0 0 0-3.062-.816h-1.019v6.94Z'
				fill='#fff'
			/>
			<path
				data-name='Path 20720'
				d='m75.524 22.861-.2-1.225h.816a2.963 2.963 0 0 0 1.225-.2c.2-.2.408-.2.408-.612V7.96c0-.2-.2-.408-.408-.612a7.243 7.243 0 0 0-1.429-.2h-.62l-.2-1.229h6.328a21.054 21.054 0 0 1 4.082.408 4.9 4.9 0 0 1 2.449 1.429 4.425 4.425 0 0 1 1.021 2.858 5.65 5.65 0 0 1-.612 2.654 3.6 3.6 0 0 1-1.837 1.633 9.4 9.4 0 0 1-4.082.612h-1.43v5.506c0 .2.2.408.408.612a2.963 2.963 0 0 0 1.225.2h.816l.2 1.225h-8.16Zm6.328-8.981a7.654 7.654 0 0 0 2.245-.2 2.721 2.721 0 0 0 1.225-1.021 3.357 3.357 0 0 0 .408-2.041c0-1.225-.2-2.245-.816-2.654a3.991 3.991 0 0 0-2.858-.816h-1.021v6.94Z'
				fill='#fff'
			/>
			<path
				data-name='Path 20721'
				d='m91.441 22.861-.2-1.429h.816c1.021 0 1.225-.2 1.225-.2.2-.2.408-.408.408-.612V7.756a.894.894 0 0 0-.2-.612 4.984 4.984 0 0 0-1.429-.2h-.2l-.2-1.225 12.439-.208.612 4.695-1.225.2v-.2a7.2 7.2 0 0 0-1.021-2.449 2.6 2.6 0 0 0-1.225-.816 7.043 7.043 0 0 0-2.449-.2h-2.04v6.124h1.429c.816 0 1.225 0 1.429-.2s.408-.2.408-.408a7.243 7.243 0 0 0 .2-1.429v-.2l1.225-.2.2 6.328-1.225.2v-.2a15.828 15.828 0 0 0-.2-1.837.439.439 0 0 0-.408-.408 11.509 11.509 0 0 0-1.429-.2h-1.629v3.47c0 2.654.2 3.062.408 3.266a2.386 2.386 0 0 0 1.633.408h1.225a6.039 6.039 0 0 0 2.041-.408 3.825 3.825 0 0 0 1.429-1.225 8 8 0 0 0 1.021-2.654v-.2l1.225-.2v.812l-.2 5.307H91.441Z'
				fill='#fff'
			/>
			<path
				data-name='Path 20722'
				d='M108.179 21.636h1.021a2.963 2.963 0 0 0 1.225-.2c.2-.2.408-.2.408-.612V7.96c0-.2-.2-.408-.2-.612a3.533 3.533 0 0 0-1.429-.2h-.612l-.2-1.225 2.654-.2c1.429 0 2.654-.2 3.674-.2a18.787 18.787 0 0 1 3.878.408 7.058 7.058 0 0 1 2.449 1.429 3.88 3.88 0 0 1 1.021 2.654 4.154 4.154 0 0 1-1.225 3.062 7.457 7.457 0 0 1-2.864 1.416 23.584 23.584 0 0 1 2.654 3.062 28.542 28.542 0 0 0 2.858 3.266 4.28 4.28 0 0 0 2.245.816h.2l.2 1.225h-4.9a19.9 19.9 0 0 1-3.674-4.491c-.408-.612-1.021-1.225-1.633-2.041s-1.01-1.018-1.01-1.224c-.2-.2-.408-.2-.816-.2h-.408v5.706c0 .2.2.408.408.612s.612.2 1.225.2h1.021l.2 1.225h-8.57Zm5.715-7.961h1.429c.612 0 1.021-.2 1.633-.2a4.462 4.462 0 0 0 1.021-.612 4.462 4.462 0 0 0 .612-1.021 3.979 3.979 0 0 0 .2-1.633 3.254 3.254 0 0 0-.816-2.449c-.408-.612-1.633-.816-3.47-.816h-.816Z'
				fill='#fff'
			/>
			<path
				data-name='Path 20723'
				d='M134.719 23.269a6 6 0 0 1-4.491-1.837c-.2.2-.2.612-.408 1.021v.2l-1.225.2-.2-5.919 1.225-.2v.2c.816 3.266 2.245 4.9 4.695 4.9a3.254 3.254 0 0 0 2.449-.816 2.621 2.621 0 0 0 .816-2.041 2.493 2.493 0 0 0-.816-1.837 8.761 8.761 0 0 0-2.862-1.629c-1.429-.612-2.449-1.225-3.062-1.429a3.6 3.6 0 0 1-1.633-1.837 4.739 4.739 0 0 1 .612-5.511 4.635 4.635 0 0 1 3.267-1.223 6.039 6.039 0 0 1 2.041.408 3.174 3.174 0 0 1 1.633 1.225 1.227 1.227 0 0 0 .2-.816v-.2l1.225-.2v4.9l-1.021.2v-.2a5.579 5.579 0 0 0-1.633-2.858 3.766 3.766 0 0 0-2.449-1.021 2.5 2.5 0 0 0-1.837.612 2.205 2.205 0 0 0-.612 1.429 1.856 1.856 0 0 0 .816 1.633 10.484 10.484 0 0 0 2.858 1.633 10.269 10.269 0 0 1 3.062 1.633 6.212 6.212 0 0 1 1.636 1.622 5.435 5.435 0 0 1 .612 2.449 5.868 5.868 0 0 1-1.426 3.676 3.836 3.836 0 0 1-3.472 1.633Z'
				fill='#fff'
			/>
			<path
				data-name='Path 20724'
				d='m179.012 22.861-.2-1.225h1.218a4.449 4.449 0 0 0 1.225-.2c.2-.2.2-.408.408-.612V7.144h-2.038a5.688 5.688 0 0 0-2.041.2c-.2 0-.612.408-.816.816a10.832 10.832 0 0 0-.612 2.245v.2l-1.225.2V6.119l16.534-.2.2 4.491-1.021.2v-.2a6.482 6.482 0 0 0-.816-2.245c-.2-.408-.612-.612-.816-.816a11.282 11.282 0 0 0-1.837-.2h-2.245v13.67c0 .2.2.612.408.612a4.449 4.449 0 0 0 1.225.2h1.021l.2 1.225Z'
				fill='#fff'
			/>
			<path
				data-name='Path 20725'
				d='M203.097 23.269a9.778 9.778 0 0 1-6.736-2.449 9.08 9.08 0 0 1-2.654-6.532 7.9 7.9 0 0 1 2.654-6.328 9.271 9.271 0 0 1 6.532-2.449 8.935 8.935 0 0 1 6.532 2.449 8.05 8.05 0 0 1 2.654 6.532 7.9 7.9 0 0 1-2.654 6.328 8.152 8.152 0 0 1-6.328 2.449Zm0-16.329a5.272 5.272 0 0 0-4.286 1.837c-1.021 1.225-1.429 3.062-1.429 5.715s.408 4.491 1.429 5.715a5.422 5.422 0 0 0 4.491 1.837 5.139 5.139 0 0 0 4.082-1.837c1.021-1.225 1.429-3.062 1.429-5.715a9.5 9.5 0 0 0-1.429-5.715 5.272 5.272 0 0 0-4.287-1.837Z'
				fill='#fff'
			/>
			<path
				data-name='Path 20726'
				d='m214.528 22.861-.2-1.225h.816c.612 0 1.021 0 1.225-.2s.408-.2.408-.612V7.96c0-.2-.2-.408-.408-.612a3.532 3.532 0 0 0-1.429-.2h-.62l-.2-1.225h6.328a19.374 19.374 0 0 1 4.082.408 4.9 4.9 0 0 1 2.449 1.429A4.425 4.425 0 0 1 228 10.618a5.65 5.65 0 0 1-.612 2.654 2.9 2.9 0 0 1-1.837 1.633 9.4 9.4 0 0 1-4.082.612h-1.429v5.502c0 .2.2.408.408.612a2.963 2.963 0 0 0 1.225.2h.816l.2 1.225h-8.165Zm6.124-8.981a7.654 7.654 0 0 0 2.245-.2c.408-.2 1.021-.408 1.225-1.021a3.448 3.448 0 0 0 .612-2.041 3.464 3.464 0 0 0-.816-2.654 4.237 4.237 0 0 0-3.062-.816h-1.021v6.94Z'
				fill='#fff'
			/>
			<path
				data-name='Path 20727'
				d='M7.756 23.27a8.175 8.175 0 0 1-5.919-2.449 3.845 3.845 0 0 0-.408 1.633v.2l-1.225.2V15.1l1.225-.2v.2q1.531 6.736 6.124 6.736a4.8 4.8 0 0 0 3.47-1.225 3.593 3.593 0 0 0 1.225-2.654 5.283 5.283 0 0 0-.816-2.858 13.63 13.63 0 0 0-4.082-2.245 26.4 26.4 0 0 1-4.082-1.837C2.043 10.201 1.023 9.588.614 8.568A5.936 5.936 0 0 1 0 5.715a5.7 5.7 0 0 1 1.633-4.082A6.587 6.587 0 0 1 5.919 0a10.342 10.342 0 0 1 2.654.408 5.724 5.724 0 0 1 2.449 1.633A3.784 3.784 0 0 0 11.43.612v-.2l1.225-.2.2 6.328-1.225.2v-.2a9.7 9.7 0 0 0-2.041-3.878 5.326 5.326 0 0 0-3.47-1.429 4.038 4.038 0 0 0-2.858 1.021 3.07 3.07 0 0 0-.816 2.245A3.38 3.38 0 0 0 3.47 6.94a25.971 25.971 0 0 0 4.082 2.449 18.368 18.368 0 0 1 4.082 2.041 5.526 5.526 0 0 1 2.245 2.041 5.315 5.315 0 0 1 .816 3.062 6.331 6.331 0 0 1-2.041 4.9 6.313 6.313 0 0 1-4.898 1.837Z'
				fill='#fff'
			/>
			<path
				data-name='Path 20728'
				d='M165.948 23.269a8.175 8.175 0 0 1-5.919-2.449 3.845 3.845 0 0 0-.408 1.633v.2l-1.225.2v-7.749l1.225-.2v.2c1.021 4.491 3.062 6.736 6.328 6.736a4.018 4.018 0 0 0 3.266-1.225 3.593 3.593 0 0 0 1.225-2.654 5.283 5.283 0 0 0-.816-2.858 13.63 13.63 0 0 0-4.082-2.245 26.4 26.4 0 0 1-4.082-1.837 6.489 6.489 0 0 1-2.449-2.245 5.545 5.545 0 0 1-.612-2.858 5.7 5.7 0 0 1 1.633-4.082 6.587 6.587 0 0 1 4.283-1.632 10.342 10.342 0 0 1 2.654.408 8.54 8.54 0 0 1 2.449 1.633 5.193 5.193 0 0 0 .408-1.429v-.2l1.225-.2v6.328h-1.02v-.2a9.7 9.7 0 0 0-2.041-3.878 5.326 5.326 0 0 0-3.47-1.429 3.221 3.221 0 0 0-2.654 1.021 3.07 3.07 0 0 0-.816 2.245 3.38 3.38 0 0 0 1.021 2.449 14.217 14.217 0 0 0 4.082 2.449 34.99 34.99 0 0 1 4.082 2.041 5.526 5.526 0 0 1 2.245 2.041 5.315 5.315 0 0 1 .816 3.062 6.051 6.051 0 0 1-2.041 4.9 7.994 7.994 0 0 1-5.307 1.824Z'
				fill='#fff'
			/>
		</svg>
	);
};
export const EcomUntickBox = (props) => {
	return (
		<svg
			data-name='Component 45 \u2013 57'
			xmlns='http://www.w3.org/2000/svg'
			width={18}
			height={18}
			{...props}
		>
			<g data-name='Rectangle 20204' fill='#fff' stroke='#707070'>
				<rect width={18} height={18} rx={2} stroke='none' />
				<rect x={0.5} y={0.5} width={17} height={17} rx={1.5} fill='none' />
			</g>
			<path
				data-name='Path 20579'
				d='m5.056 9.939 2.262 2.1 5.625-6.084'
				fill='none'
				stroke='none'
				strokeLinecap='round'
			/>
		</svg>
	);
};
export const EcomcheckedBox = (props) => {
	return (
		<svg
			data-name='Component 45 \u2013 57'
			xmlns='http://www.w3.org/2000/svg'
			width={18}
			height={18}
			{...props}
		>
			<g
				data-name='Rectangle 20204'
				fill='#fff'
				stroke={props.color ? props.color : '#e13e79'}
			>
				<rect width={18} height={18} rx={2} stroke='none' />
				<rect x={0.5} y={0.5} width={17} height={17} rx={1.5} fill='none' />
			</g>
			<path
				data-name='Path 20579'
				d='m5.056 9.939 2.262 2.1 5.625-6.084'
				fill='none'
				stroke={props.color ? props.color : '#e13e79'}
				strokeLinecap='round'
			/>
		</svg>
	);
};

export const Sneakers = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={500}
			height={500}
			style={{
				width: '100%',
				height: '100%',
				contentVisibility: 'visible',
			}}
			viewBox='0 0 500 500'
			{...props}
		>
			<defs>
				<clipPath id='a'>
					<path d='M0 0H500V500H0z' />
				</clipPath>
			</defs>
			<g clipPath='url(#a)' display='block'>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M14 0h-28'
					transform='matrix(10 0 0 10 -7650 -6850) translate(796 715)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M4 0h-8'
					transform='matrix(10 0 0 10 -7650 -6850) translate(774 715)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-18 10h38V-6h-6c-3.055-.016-7.055-1.517-9-4q0 0 0 0L0-6c-1.268.843-3.526 1.75-5 2l-5 1c-4.2.712-10 3.924-10 8v3c0 1.018 1.049 2 2 2'
					transform='matrix(10 0 0 10 -7650 -6850) translate(790 710)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M0-1.5v3'
					transform='matrix(10 0 0 10 -7650 -6850) translate(785 707.5)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M0-2v4'
					transform='matrix(10 0 0 10 -7650 -6850) translate(789 707)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M0-3.5v7'
					transform='matrix(10 0 0 10 -7650 -6850) translate(793 705.5)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-2.749-2.864v.138c0 3.087 2.461 5.59 5.498 5.59q0 0 0 0'
					transform='matrix(10 0 0 10 -7650 -6850) translate(806.749 707.864)'
				/>
			</g>
		</svg>
	);
};
export const Shorts = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={500}
			height={500}
			style={{
				width: '100%',
				height: '100%',
				contentVisibility: 'visible',
			}}
			viewBox='0 0 500 500'
			{...props}
		>
			<defs>
				<clipPath id='a'>
					<path d='M0 0H500V500H0z' />
				</clipPath>
			</defs>
			<g clipPath='url(#a)' display='block'>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-15 0h30'
					transform='matrix(10 0 0 10 -11050 -4810) translate(1130 499)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M3 2.5h-6v-5'
					transform='matrix(10 0 0 10 -11050 -4810) translate(1143 501.5)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-8.401 2.352 8.401-2.352'
					transform='matrix(10 0 0 10 -11050 -4810) translate(1140.472 512.837)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M.278 5.157 3.514 12 20 7.009 13.714-12h-27.428L-20 7.009-3.515 12z'
					transform='matrix(10 0 0 10 -11050 -4810) translate(1130 506)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-2-6V6h4V-6'
					transform='matrix(10 0 0 10 -11050 -4810) translate(1130 505)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-3 2.5h6v-5'
					transform='matrix(10 0 0 10 -11050 -4810) translate(1117 501.5)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M8.401 2.352-8.401-2.352'
					transform='matrix(10 0 0 10 -11050 -4810) translate(1119.528 512.837)'
				/>
			</g>
		</svg>
	);
};

export const Skirt = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={500}
			height={500}
			style={{
				width: '100%',
				height: '100%',
				contentVisibility: 'visible',
			}}
			viewBox='0 0 500 500'
			{...props}
		>
			<defs>
				<clipPath id='a'>
					<path d='M0 0H500V500H0z' />
				</clipPath>
			</defs>
			<g clipPath='url(#a)' display='block'>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M10-13q0 0 0 0v-4h-20v4q0 0 0 0l-9 27s5.254 3 18.98 3S19 14 19 14z'
					transform='matrix(10 0 0 10 -7650 -5490) translate(790 574)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-1.5 0h3'
					transform='matrix(10 0 0 10 -7650 -5490) translate(798.5 561)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-1.5 0h3'
					transform='matrix(10 0 0 10 -7650 -5490) translate(781.5 561)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-3 0h6'
					transform='matrix(10 0 0 10 -7650 -5490) translate(790 561)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='m-1.674-1.622 3.348 3.244'
					transform='matrix(10 0 0 10 -7650 -5490) translate(791.694 562.622)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='m1.674-1.622-3.348 3.244'
					transform='matrix(10 0 0 10 -7650 -5490) translate(788.306 562.622)'
				/>
			</g>
		</svg>
	);
};
export const HandBag = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={500}
			height={500}
			style={{
				width: '100%',
				height: '100%',
				contentVisibility: 'visible',
			}}
			viewBox='0 0 500 500'
			{...props}
		>
			<defs>
				<clipPath id='a'>
					<path d='M0 0H500V500H0z' />
				</clipPath>
			</defs>
			<g clipPath='url(#a)' display='block'>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-10 9V1C-10-4.523-5.523-9 0-9q0 0 0 0C5.523-9 10-4.523 10 1v8'
					transform='matrix(10 0 0 10 -10370 -6170) translate(1062 634)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M9.529-11H6.966C5.88-11 5-10.12 5-9.034v.068C5-7.88 4.12-7 3.034-7h-6.068A1.966 1.966 0 0 1-5-8.966v-.068C-5-10.12-5.88-11-6.966-11h-2.563A8.47 8.47 0 0 0-18-2.529V11h36V-2.529A8.47 8.47 0 0 0 9.529-11'
					transform='matrix(10 0 0 10 -10370 -6170) translate(1062 648)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-5.987-2.459h5.293a4.26 4.26 0 0 1 3.011 1.247l3.67 3.671'
					transform='matrix(10 0 0 10 -10370 -6170) translate(1049.987 656.459)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M5.987-2.459H.694a4.26 4.26 0 0 0-3.011 1.247l-3.67 3.671'
					transform='matrix(10 0 0 10 -10370 -6170) translate(1074.013 656.459)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-4.5 0h9'
					transform='matrix(10 0 0 10 -10370 -6170) translate(1062.5 651)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-2.5 0h5'
					transform='matrix(10 0 0 10 -10370 -6170) translate(1071.5 644)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-2.5 0h5'
					transform='matrix(10 0 0 10 -10370 -6170) translate(1052.5 644)'
				/>
			</g>
		</svg>
	);
};
export const HighHeeledSandal = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={500}
			height={500}
			style={{
				width: '100%',
				height: '100%',
				contentVisibility: 'visible',
			}}
			viewBox='0 0 500 500'
			{...props}
		>
			<defs>
				<clipPath id='a'>
					<path d='M0 0H500V500H0z' />
				</clipPath>
			</defs>
			<g clipPath='url(#a)' display='block'>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-18 6.669h14.549a7.84 7.84 0 0 0 6.185-3.031C5.801-.298 10.79-6.669 18-6.669V6.669h-2.613s.149-5.845-3.294-11.456'
					transform='matrix(10 0 0 10 -9690 -6850) translate(994 714.331)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M8.114 2.186 3.599-3.93-8.114-.91v4.84'
					transform='matrix(10 0 0 10 -9690 -6850) translate(987.114 717.07)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M7 .138C7-6.202 5.508-8.5 5.508-8.5-2.26-8.5-7-.459-7 4.474V8.5'
					transform='matrix(10 0 0 10 -9690 -6850) translate(1005 707.5)'
				/>
			</g>
		</svg>
	);
};
export const Purse = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={500}
			height={500}
			style={{
				width: '100%',
				height: '100%',
				contentVisibility: 'visible',
			}}
			viewBox='0 0 500 500'
			{...props}
		>
			<defs>
				<clipPath id='a'>
					<path d='M0 0H500V500H0z' />
				</clipPath>
			</defs>
			<g clipPath='url(#a)' display='block'>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M13.318 10h-26.636c-2.124 0-3.808-1.917-3.675-4.184l.872-14.801c.033-.57.476-1.015 1.01-1.015h30.222c.534 0 .977.445 1.01 1.015l.872 14.801C17.126 8.083 15.442 10 13.318 10'
					transform='matrix(10 0 0 10 -11050 -6170) translate(1130 642)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M6.513-5.291C4.141.451-.814 4.407-6.513 5.291'
					transform='matrix(10 0 0 10 -11050 -6170) translate(1139.379 637.922)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M6.575 5.3C.824 4.454-4.186.484-6.575-5.3'
					transform='matrix(10 0 0 10 -11050 -6170) translate(1120.682 637.932)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M0-3.5v7'
					transform='matrix(10 0 0 10 -11050 -6170) translate(1130 643.5)'
				/>
			</g>
		</svg>
	);
};
export const WristWatch = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={500}
			height={500}
			style={{
				width: '100%',
				height: '100%',
				contentVisibility: 'visible',
			}}
			viewBox='0 0 500 500'
			{...props}
		>
			<defs>
				<clipPath id='a'>
					<path d='M0 0H500V500H0z' />
				</clipPath>
			</defs>
			<g clipPath='url(#a)' display='block'>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M5.657 5.657A8 8 0 1 1-5.657-5.658 8 8 0 0 1 5.657 5.657'
					transform='matrix(10 0 0 10 -9010 -6170) translate(926 642)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M1.682-2.982-1.682.383.917 2.982'
					transform='matrix(10 0 0 10 -9010 -6170) translate(927.682 641.617)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='m-4.167-4.167 8.334 8.334'
					transform='matrix(10 0 0 10 -9010 -6170) translate(933.987 634.013)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='m-4.167-4.167 8.334 8.334'
					transform='matrix(10 0 0 10 -9010 -6170) translate(936.41 631.59)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='m-4.167-4.167 8.334 8.334'
					transform='matrix(10 0 0 10 -9010 -6170) translate(938.833 629.167)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='m-4.167-4.167 8.334 8.334'
					transform='matrix(10 0 0 10 -9010 -6170) translate(913.167 654.833)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='m-4.167-4.167 8.334 8.334'
					transform='matrix(10 0 0 10 -9010 -6170) translate(915.59 652.41)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='m-4.167-4.167 8.334 8.334'
					transform='matrix(10 0 0 10 -9010 -6170) translate(918.013 649.987)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='m1.294-1.294-2.588 2.588'
					transform='matrix(10 0 0 10 -9010 -6170) translate(918.696 634.696)'
				/>
			</g>
		</svg>
	);
};
export const TShirt = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={500}
			height={500}
			style={{
				width: '100%',
				height: '100%',
				contentVisibility: 'visible',
			}}
			viewBox='0 0 500 500'
			{...props}
		>
			<defs>
				<clipPath id='a'>
					<path d='M0 0H500V500H0z' />
				</clipPath>
			</defs>
			<g clipPath='url(#a)' display='block'>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M12-13v26h-24v-26'
					transform='matrix(10 0 0 10 -8330 -4810) translate(858 509)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M12 7h5v-9a5 5 0 0 0-5-5h-24a5 5 0 0 0-5 5v9h5'
					transform='matrix(10 0 0 10 -8330 -4810) translate(858 497)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M6.382-3.191a6.382 6.382 0 1 1-12.764 0'
					transform='matrix(10 0 0 10 -8330 -4810) translate(858 493.732)'
				/>
			</g>
		</svg>
	);
};
export const Hoodie = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={500}
			height={500}
			style={{
				width: '100%',
				height: '100%',
				contentVisibility: 'visible',
			}}
			viewBox='0 0 500 500'
			{...props}
		>
			<defs>
				<clipPath id='a'>
					<path d='M0 0H500V500H0z' />
				</clipPath>
			</defs>
			<g clipPath='url(#a)' display='block'>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-3 4.021v-5.33l2.543-2.543a.58.58 0 0 1 .818 0L3-1.213v5.234'
					transform='matrix(10 0 0 10 -9690 -4814) translate(994 507.979)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M10 18.5h5v-17a5 5 0 0 0-5-5H7v-8a7 7 0 0 0-7-7q0 0 0 0a7 7 0 0 0-7 7v8h-3a5 5 0 0 0-5 5v17h5'
					transform='matrix(10 0 0 10 -9690 -4814) translate(994 504.5)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M0 6.5q0 0 0 0a4 4 0 0 1-4-4v-5a4 4 0 0 1 4-4q0 0 0 0a4 4 0 0 1 4 4v5a4 4 0 0 1-4 4'
					transform='matrix(10 0 0 10 -9690 -4814) translate(994 497.5)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M984.4 507.6v19.2h18.9v-19.2'
					transform='matrix(10 0 0 10 -9690 -4814)'
				/>
			</g>
		</svg>
	);
};
export const FormalShirt = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={500}
			height={500}
			style={{
				width: '100%',
				height: '100%',
				contentVisibility: 'visible',
			}}
			viewBox='0 0 500 500'
			{...props}
		>
			<defs>
				<clipPath id='a'>
					<path d='M0 0H500V500H0z' />
				</clipPath>
			</defs>
			<g clipPath='url(#a)' display='block'>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M11-14v28h-22v-28'
					transform='matrix(10 0 0 10 -8330 -4130) translate(858 442)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M4.5-14.5h-4a5 5 0 0 0-5 5v24h6'
					transform='matrix(10 0 0 10 -8330 -4130) translate(845.5 437.5)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-1.5 14.5h6v-24a5 5 0 0 0-5-5h-4'
					transform='matrix(10 0 0 10 -8330 -4130) translate(870.5 437.5)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='m4 2.5-4.307 3L-4-2.5l3-3z'
					transform='matrix(10 0 0 10 -8330 -4130) translate(854 425.5)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='m-4 2.5 4 3 4-8-3-3z'
					transform='matrix(10 0 0 10 -8330 -4130) translate(862 425.5)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M0-11v22'
					transform='matrix(10 0 0 10 -8330 -4130) translate(858 439)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-2.5 0h5'
					transform='matrix(10 0 0 10 -8330 -4130) translate(844.5 449)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-3 0h6'
					transform='matrix(10 0 0 10 -8330 -4130) translate(872 449)'
				/>
			</g>
		</svg>
	);
};

export const MenSleevedTShirt = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={500}
			height={500}
			style={{
				width: '100%',
				height: '100%',
				contentVisibility: 'visible',
			}}
			viewBox='0 0 500 500'
			{...props}
		>
			<defs>
				<clipPath id='a'>
					<path d='M0 0H500V500H0z' />
				</clipPath>
			</defs>
			<g clipPath='url(#a)' display='block'>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M12-14v28h-24v-28'
					transform='matrix(10 0 0 10 -8330 -5490) translate(858 577)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M12 15h6v-25a5 5 0 0 0-5-5h-26a5 5 0 0 0-5 5v25h6'
					transform='matrix(10 0 0 10 -8330 -5490) translate(858 572)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-12 0h24'
					transform='matrix(10 0 0 10 -8330 -5490) translate(858 568)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-12 0h24'
					transform='matrix(10 0 0 10 -8330 -5490) translate(858 572)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-12 0h24'
					transform='matrix(10 0 0 10 -8330 -5490) translate(858 576)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-2.5 0h5'
					transform='matrix(10 0 0 10 -8330 -5490) translate(843.5 583)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-2.5 0h5'
					transform='matrix(10 0 0 10 -8330 -5490) translate(872.5 583)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M6.481-3a6.5 6.5 0 0 1-12.962.012'
					transform='matrix(10 0 0 10 -8330 -5490) translate(858 560.5)'
				/>
			</g>
		</svg>
	);
};
export const WomenDress = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={500}
			height={500}
			style={{
				width: '100%',
				height: '100%',
				contentVisibility: 'visible',
			}}
			viewBox='0 0 500 500'
			{...props}
		>
			<defs>
				<clipPath id='a'>
					<path d='M0 0H500V500H0z' />
				</clipPath>
			</defs>
			<g clipPath='url(#a)' display='block'>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M10.983 3.659 16 .803c0-2.464-2.1-4.462-4.69-4.462H6.032L0 3.46l-6.404-7.119h-4.906C-13.9-3.659-16-1.661-16 .803l5.017 2.856'
					transform='matrix(10 0 0 10 -11050 -4130) translate(1130 425.659)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M1.381 14A72.6 72.6 0 0 0-1.571-.658q0 0 0 0l1.143-1.844C.884-4.618 1.571-6.984 1.571-9.386V-14'
					transform='matrix(10 0 0 10 -11050 -4130) translate(1139.429 440)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-1.571-14v4.614c0 2.402.687 4.768 1.999 6.884L1.571-.658q0 0 0 0A72.6 72.6 0 0 0-1.381 14'
					transform='matrix(10 0 0 10 -11050 -4130) translate(1120.571 440)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-3 0h6'
					transform='matrix(10 0 0 10 -11050 -4130) translate(1125 439)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-1.5 0h3'
					transform='matrix(10 0 0 10 -11050 -4130) translate(1136.5 439)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M0-4.5v9'
					transform='matrix(10 0 0 10 -11050 -4130) translate(1132 443.5)'
				/>
			</g>
		</svg>
	);
};
export const Pants = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={500}
			height={500}
			style={{
				width: '100%',
				height: '100%',
				contentVisibility: 'visible',
			}}
			viewBox='0 0 500 500'
			{...props}
		>
			<defs>
				<clipPath id='a'>
					<path d='M0 0H500V500H0z' />
				</clipPath>
			</defs>
			<g clipPath='url(#a)' display='block'>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='m-1.488 9.5 2.976-19'
					transform='matrix(10 0 0 10 -9690 -4130) translate(992.512 447.5)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M14 19v-38h-28v38'
					transform='matrix(10 0 0 10 -9690 -4130) translate(994 438)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='m-1.588-9.5 3.176 19'
					transform='matrix(10 0 0 10 -9690 -4130) translate(995.67 447.5)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-4 0h8'
					transform='matrix(10 0 0 10 -9690 -4130) translate(994 438)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-14 0h28'
					transform='matrix(10 0 0 10 -9690 -4130) translate(994 424)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M2.5-6.652v8.304l-5 5'
					transform='matrix(10 0 0 10 -9690 -4130) translate(982.5 430.652)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-3-7.152v8.304l6 6'
					transform='matrix(10 0 0 10 -9690 -4130) translate(1005 431.152)'
				/>
			</g>
		</svg>
	);
};
export const WomenTShirt = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={500}
			height={500}
			style={{
				width: '100%',
				height: '100%',
				contentVisibility: 'visible',
			}}
			viewBox='0 0 500 500'
			{...props}
		>
			<defs>
				<clipPath id='a'>
					<path d='M0 0H500V500H0z' />
				</clipPath>
			</defs>
			<g clipPath='url(#a)' display='block'>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M11-12v3.682L9 .698V12H-9V.698l-2-8.927V-12'
					transform='matrix(10 0 0 10 -10370 -4130) translate(1062 442)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M11 7h6v-9a5 5 0 0 0-5-5h-24a5 5 0 0 0-5 5v9h5.999'
					transform='matrix(10 0 0 10 -10370 -4130) translate(1062 429)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M6.158-3.079a6.158 6.158 0 1 1-12.316 0'
					transform='matrix(10 0 0 10 -10370 -4130) translate(1062 425.197)'
				/>
			</g>
		</svg>
	);
};

export const Gem = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={500}
			height={500}
			style={{
				width: '100%',
				height: '100%',
				contentVisibility: 'visible',
			}}
			viewBox='0 0 500 500'
			{...props}
		>
			<defs>
				<clipPath id='a'>
					<path d='M0 0H500V500H0z' />
				</clipPath>
			</defs>
			<g clipPath='url(#a)' display='block'>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M18-3.862 0 14-18-3.862-12.064-14h24.128z'
					transform='matrix(10 0 0 10 -9690 -6170) translate(994 642)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M18 0h-36'
					transform='matrix(10 0 0 10 -9690 -6170) translate(994 638)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M5.886-5 0 5-5.886-5'
					transform='matrix(10 0 0 10 -9690 -6170) translate(988.114 633.191)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M5.886-5 0 5-5.886-5q0 0 0 0'
					transform='matrix(10 0 0 10 -9690 -6170) translate(999.886 633)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-5.885-8.163-.507 7.78a.54.54 0 0 0 1.031.005L5.885-8.163'
					transform='matrix(10 0 0 10 -9690 -6170) translate(994 646.301)'
				/>
			</g>
		</svg>
	);
};
export const HighHeelBoot = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={500}
			height={500}
			style={{
				width: '100%',
				height: '100%',
				contentVisibility: 'visible',
			}}
			viewBox='0 0 500 500'
			{...props}
		>
			<defs>
				<clipPath id='a'>
					<path d='M0 0H500V500H0z' />
				</clipPath>
			</defs>
			<g clipPath='url(#a)' display='block'>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-1-18C-.341-8.735 1.52-7.257.954.813a1.74 1.74 0 0 1-.357.943C-.778 3.493-1.921 4.282-3.792 7.741-5.8 11.45-7.746 13.442-11 14c-1.887.001-3 .961-3 3 0 .771.616 1 1 1H1.534c1.329-.13 1.533-3.932 3.737-6.469.932-1.073 2.726-.464 2.729.941V18h3c0-9.554 3-9.879 3-13s-1.374-3.937-2-7c-1.196-5.854-.715-9.02 1-16z'
					transform='matrix(10 0 0 10 -8330 -6850) translate(858 710)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M0-5.5v11'
					transform='matrix(10 0 0 10 -8330 -6850) translate(864 697.5)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M0-1.5v3'
					transform='matrix(10 0 0 10 -8330 -6850) translate(864 707.5)'
				/>
			</g>
		</svg>
	);
};
export const FormalWomen = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={500}
			height={500}
			style={{
				width: '100%',
				height: '100%',
				contentVisibility: 'visible',
			}}
			viewBox='0 0 500 500'
			{...props}
		>
			<defs>
				<clipPath id='a'>
					<path d='M0 0H500V500H0z' />
				</clipPath>
			</defs>
			<g clipPath='url(#a)' display='block'>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M12-12v4.63s-.53 3.292-1.006 4.872L10 .737V12h-20V.737l-1.017-3.271C-11.478-4.091-12-7.329-12-7.329V-12'
					transform='matrix(10 0 0 10 -10370 -4810) translate(1062 511)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-2.5 0h5'
					transform='matrix(10 0 0 10 -10370 -4810) translate(1069.5 518)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-2.5 0h5'
					transform='matrix(10 0 0 10 -10370 -4810) translate(1054.5 518)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M4-14H1a5 5 0 0 0-5 5v23h7'
					transform='matrix(10 0 0 10 -10370 -4810) translate(1049 506)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-3 14h7V-9a5 5 0 0 0-5-5h-3'
					transform='matrix(10 0 0 10 -10370 -4810) translate(1075 506)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-3.5 0h7'
					transform='matrix(10 0 0 10 -10370 -4810) translate(1048.5 516)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-3.5 0h7'
					transform='matrix(10 0 0 10 -10370 -4810) translate(1075.5 516)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M4.5 1.613.456 5-4.5-2l3.196-3z'
					transform='matrix(10 0 0 10 -10370 -4810) translate(1057.5 494)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-4.5 1.613-.456 5 4.5-2 1.304-5z'
					transform='matrix(10 0 0 10 -10370 -4810) translate(1066.5 494)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M0-13.5v27'
					transform='matrix(10 0 0 10 -10370 -4810) translate(1062 509.5)'
				/>
			</g>
		</svg>
	);
};
export const HighHeeledBoot = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={500}
			height={500}
			style={{
				width: '100%',
				height: '100%',
				contentVisibility: 'visible',
			}}
			viewBox='0 0 500 500'
			{...props}
		>
			<defs>
				<clipPath id='a'>
					<path d='M0 0H500V500H0z' />
				</clipPath>
			</defs>
			<g clipPath='url(#a)' display='block'>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M-1-18C-.341-8.735 1.52-7.257.954.813a1.74 1.74 0 0 1-.357.943C-.778 3.493-1.921 4.282-3.792 7.741-5.8 11.45-7.746 13.442-11 14c-1.887.001-3 .961-3 3 0 .771.616 1 1 1H1.534c1.329-.13 1.533-3.932 3.737-6.469.932-1.073 2.726-.464 2.729.941V18h3c0-9.554 3-9.879 3-13s-1.374-3.937-2-7c-1.196-5.854-.715-9.02 1-16z'
					transform='matrix(10 0 0 10 -8330 -6850) translate(858 710)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M0-5.5v11'
					transform='matrix(10 0 0 10 -8330 -6850) translate(864 697.5)'
				/>
				<path
					fill='none'
					stroke={props.color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1}
					d='M0-1.5v3'
					transform='matrix(10 0 0 10 -8330 -6850) translate(864 707.5)'
				/>
			</g>
		</svg>
	);
};
export const MicEcom = (props) => {
	return (
		<svg
			width={36}
			height={36}
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<mask
				id='a'
				style={{
					maskType: 'alpha',
				}}
				maskUnits='userSpaceOnUse'
				x={0}
				y={0}
				width={36}
				height={36}
			>
				<path fill='#D9D9D9' d='M0 0h36v36H0z' />
			</mask>
			<g mask='url(#a)'>
				<path
					d='M18 21c-1.25 0-2.313-.438-3.188-1.313S13.5 17.75 13.5 16.5v-9c0-1.25.437-2.313 1.312-3.188S16.75 3 18 3c1.25 0 2.312.438 3.187 1.313S22.5 6.25 22.5 7.5v9c0 1.25-.438 2.313-1.313 3.188S19.25 21 18 21Zm-1.5 9v-3.113c-2.3-.325-4.27-1.3-5.907-2.925-1.637-1.625-2.63-3.6-2.98-5.924-.05-.425.062-.788.337-1.088.275-.3.625-.45 1.05-.45.425 0 .78.144 1.068.431.288.288.482.644.582 1.069.35 1.75 1.218 3.188 2.606 4.313C14.643 23.438 16.225 24 18 24c1.8 0 3.387-.569 4.762-1.706C24.137 21.156 25 19.725 25.35 18c.1-.425.293-.781.58-1.069A1.451 1.451 0 0 1 27 16.5c.425 0 .775.15 1.05.45.275.3.387.663.337 1.088-.35 2.274-1.337 4.237-2.962 5.887-1.625 1.65-3.6 2.637-5.925 2.962V30c0 .425-.144.781-.432 1.069A1.452 1.452 0 0 1 18 31.5c-.425 0-.782-.144-1.07-.431A1.451 1.451 0 0 1 16.5 30Z'
					fill='#501ACE'
				/>
			</g>
		</svg>
	);
};

export const CloseInput = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='none'
		>
			<path
				d='M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z'
				fill='black'
			/>
		</svg>
	);
};
export const AccordionIcon = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={24}
			height={24}
			fill='none'
			viewBox='0 0 24 24'
			{...props}
		>
			<path
				fill='#000'
				fillOpacity={0.6}
				d='m12 15.705 6-6-1.41-1.41-4.59 4.58-4.59-4.58L6 9.705z'
			/>
		</svg>
	);
};
export const SortTick = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={24}
			height={24}
			fill='none'
			viewBox='0 0 24 24'
			{...props}
		>
			<path
				fill='var(--primary-color-ff-primary500)'
				d='m8.795 15.875-4.17-4.17-1.42 1.41 5.59 5.59 12-12-1.41-1.41z'
			/>
		</svg>
	);
};
